import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Button,
  Drawer,
  FileButton,
  Flex,
  Grid,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useRef, useState } from "react";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconCheck,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileDownload,
  IconFileUpload,
  IconFilter,
  IconFolder,
  IconFolderOpen,
  IconSearch,
  IconStar,
  IconStarOff,
  IconTimeDuration15,
  IconTrash,
  IconListCheck,
} from "@tabler/icons-react";

import { EuiFlexGroup, EuiFlexItem, EuiLink } from "@elastic/eui";
import { modals } from "@mantine/modals";
import { IconEdit } from "@tabler/icons-react";

import BreadCrumb from "../../_base/component/_layout/_breadcrumb";
import { modifyItemStatus } from "../../api/ApiProduct";
import AppAction from "../../common/AppAction";
import { _localization } from "../../config/location";
import EditView from "./EditView/editView";

import { IconClick } from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../_base/extension/StringExtension";
import { datavisibleType } from "../../_data-fix/datavisibleType";
import {
  deleteItemCategory,
  EditPriority,
  EditStatus,
  getDataTreeForm,
} from "../../api/ApiMegaMenu";
import LoadingOverlayCustom from "../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_URL } from "../../config";
import { CategoryModelTreeNew } from "../../model/TblCategoryModel";
import CreateView from "./CreateView/createView";
import ProductCategory from "./ProductCategory";
import UpdateOrderNumberView from "./updateorderNumberView";

type Props = {
  isModal?: boolean;
  setValueCategory?: any; // Hàm để cập nhật giá trị danh mục
};

const HomeViewCategoryV2 = ({ isModal, setValueCategory }: Props) => {
  const location = useLocation();
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<CategoryModelTreeNew[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 100,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([
    {
      id: "orderedNumber",
      desc: true, // true = giảm dần, false = tăng dần
    },
  ]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [file, setFile] = useState<File | null>(null);
  const resetRef = useRef<() => void>(null);
  const [categorySelect, setCategorySelect] = useState<any>({});
  const [
    openedProductCategory,
    { open: openProductCategory, close: closeProductCategory },
  ] = useDisclosure(false);

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [error, setError] = useState<string | undefined>();

  const [deleteViewStatus, setDeleteViewStatus] = useState(0);

  // đoạn check đặc điểm sản phẩm switchcase trả về label

  const formSeachInput = useForm<{
    KeySearch: string;
    Active: boolean;
  }>({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      Active: _searchJson && checkedPinSearch ? _searchJson?.Active : null,
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const getFormattedIndex = (row: any): string => {
            let index = row.index + 1;
            let parent = row.getParentRow?.();
            let formatted = `${index}`;
            while (parent) {
              formatted = `${parent.index + 1}.${formatted}`;
              parent = parent.getParentRow?.();
            }
            return formatted;
          };

          const getColorByDepth = (depth: number) => {
            switch (depth) {
              case 0:
                return "#333"; // đen nhạt
              // case 1:
              //   return "#4c6ef5"; // xanh lam nhạt
              // case 2:
              //   return "#38d9a9"; // xanh lá nhạt
              default:
                return "#333";
            }
          };

          const getIconByDepth = (depth: number) => {
            const size = 16; // Kích thước nhỏ hơn
            switch (depth) {
              case 0:
                return <IconFolder size={size} color="#333" />; // icon cho cha
              case 1:
                return <IconFolderOpen size={size} color="#4c6ef5" />; // icon cho con cấp 1
              case 2:
                return <IconFile size={size} color="#38d9a9" />; // icon cho con cấp 2
              default:
                return <IconFile size={size} color="#f76707" />; // icon cho con cấp sâu hơn
            }
          };

          return (
            <Flex align="center" gap="xs">
              {getIconByDepth(row.depth)}
              <span
                style={{
                  color: getColorByDepth(row.depth),
                  fontWeight: 500,
                  fontSize: 14,
                }}
              >
                {getFormattedIndex(row)}
              </span>
            </Flex>
          );
        },
      },

      //   {
      //     accessorKey: "categoryCode",
      //     header: "Mã danh mục",
      //     size: 300,
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      //   },
      {
        accessorKey: "categoryName",
        header: "Tên danh mục",
        size: 300,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "priorityStatus",
        header: "Nổi bật",
        size: 300,
        Cell: ({ row }) => {
          const isPriority = row.original.priorityStatus === "Y";
          const iconSize = 16; // Kích thước nhỏ hơn
          const icon = isPriority ? (
            <IconStar size={iconSize} color="blue" />
          ) : (
            <IconStarOff size={iconSize} color="red" />
          );
          const color = isPriority ? "blue" : "red";

          return (
            <Flex
              style={{
                cursor: "pointer",
              }}
              align="center"
              gap="xs"
              onClick={async (e: any) => {
                open();
                await priorityStatusActive(row.original.id);
              }}
            >
              {icon}
              <Text c={color} fw={500} size="sm">
                {isPriority ? "Hạ nổi bật" : "Cho nổi bật"}
              </Text>
            </Flex>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ row }) => {
          const isActive = row.original.status === "A";
          const iconSize = 16; // Kích thước nhỏ hơn
          const icon = isActive ? (
            <IconEye size={iconSize} color="green" />
          ) : (
            <IconEyeOff size={iconSize} color="gray" />
          );
          const color = isActive ? "green" : "gray";

          return (
            <Flex
              style={{
                cursor: "pointer",
              }}
              align="center"
              gap="xs"
              onClick={async (e: any) => {
                await statusActive(row.original.id);
              }}
            >
              {icon}
              <Text c={color} fw={500} size="sm">
                {isActive ? "Hiển thị" : "Không hiển thị"}
              </Text>
            </Flex>
          );
        },
      },
      {
        accessorKey: "id",
        header: "Id",
        size: 100,
        Cell: ({ row }) => <EuiLink>{row.original.id}</EuiLink>,
      },
      {
        accessorKey: "visit",
        header: "Xem",
        size: 100,
        Cell: ({ row }) => (
          <EuiLink>{row.original.visit ? row.original.visit : ""}</EuiLink>
        ),
      },
      {
        accessorKey: "itemCount",
        header: "SP",
        size: 100,
        Cell: ({ row }) => (
          <EuiLink
            target="_blank"
            onClick={(e: any) =>
              handleNavigatePreview(row.original.categoryName, row.original.id)
            }
          >
            {row.original.itemCount}
          </EuiLink>
        ),
      },
      {
        accessorKey: "orderedNumber",
        header: "STT(Hiển thị)",
        Cell: ({ row }) => {
          return (
            <Anchor
              fw={500}
              c="blue"
              ml={10}
              underline="hover"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const id = row.original.id;
                const orderedNumber = row.original.orderedNumber;
                modals.openConfirmModal({
                  title: (
                    <>
                      <div color="white">
                        <Title order={5}>Cập nhật STT !</Title>
                      </div>
                    </>
                  ),
                  children: (
                    <UpdateOrderNumberView
                      id={id}
                      orderNumber={orderedNumber ?? 0}
                      users={data}
                      fetchData={fetchData}
                    />
                  ),
                  confirmProps: { display: "none" },
                  cancelProps: { display: "none" },
                });
              }}
            >
              {row.original.orderedNumber ?? 0}
            </Anchor>
          );
        },
      },
      {
        accessorKey: "visibleType",
        header: "Hiển thị nội dung",
        size: 200,
        Cell: ({ row }) => {
          const res = datavisibleType.find(
            (x) => x.value == row.original.visibleType
          );
          return <Text>{res?.label}</Text>;
        },
      },

      {
        accessorKey: "action",
        header: "Thao tác",
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Flex direction={"column"}>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
              justifyContent="center"
              style={{
                marginLeft: "20px",
              }}
            >
              {!isModal ? (
                <>
                  <EuiFlexItem grow={false} style={{ textAlign: "center" }}>
                    <Flex gap={"xs"}>
                      <Tooltip label="Chỉnh sửa danh mục">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="green"
                          onClick={(e: any) => {
                            editItem(row.original.id, "edit");
                          }}
                        >
                          <IconEdit />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip label="Xem sản phẩm chưa có thuộc tính">
                        <ActionIcon
                          variant="light"
                          aria-label="Missing Attributes"
                          color="orange"
                          onClick={() => {
                            navigate(`/product-manager/list-product-no-attribute?cat_id=${row.original.id}`);
                          }}
                        >
                          <IconListCheck />
                        </ActionIcon>
                      </Tooltip>
                      <Tooltip label="Xóa danh mục">
                        <ActionIcon
                          variant="light"
                          aria-label="Settings"
                          color="red"
                          onClick={() => {
                            deleteItem([row.original.id]);
                          }}
                        >
                          <IconTrash />
                        </ActionIcon>
                      </Tooltip>
                    </Flex>
                  </EuiFlexItem>
                </>
              ) : (
                <>
                  <EuiFlexItem grow={false} style={{ textAlign: "center" }}>
                    <Tooltip label="Chọn danh mục">
                      <ActionIcon
                        variant="light"
                        aria-label="Select"
                        color="blue"
                        onClick={(e: any) => {
                          if (setValueCategory) {
                            setValueCategory([row.original.id?.toString()]);
                            modals.closeAll();
                          }
                        }}
                      >
                        <IconClick stroke={2} />
                      </ActionIcon>
                    </Tooltip>
                  </EuiFlexItem>
                </>
              )}
              <Tooltip label="Export excel sản phẩm theo danh mục">
                <ActionIcon
                  variant="light"
                  onClick={() => exportExcel(Number(row.original.id))}
                  color="teal"
                >
                  <IconFileDownload />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Danh sách sản phẩm của danh mục">
                <ActionIcon
                  variant="light"
                  onClick={() => {
                    openProductCategory();
                    setCategorySelect({
                      categorySelect: row.original.id,
                      categoryName: row.original.categoryName,
                    });
                  }}
                >
                  <IconEye />
                </ActionIcon>
              </Tooltip>
            </EuiFlexGroup>
            <Flex justify={"center"}>
              <Anchor
                href={`${hacomUrl}${row.original.requestPath}`}
                underline="always"
                target="_blank"
                style={{
                  marginLeft: "10px",
                }}
              >
                Xem tại web
              </Anchor>
            </Flex>
          </Flex>
        ),
      },
    ],
    []
  );
  // Chuyển đến trang xem sản phẩm của danh mục sản phẩm
  const navigate = useNavigate();
  const handleNavigatePreview = (categoryName: string, categoryId: number) => {
    if (categoryName && !isModal) {
      navigate(
        `/product-list?categoryName=${encodeURIComponent(
          categoryName
        )}&categoryId=${categoryId}`
      );
    } else {
      console.error("Category name is missing");
    }
  };

  // Cập nhật nổi bật của danh mục sản phẩm
  const priorityStatusActive = async (id: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      open();
      try {
        let urlSearch = "?id=" + id;
        let callapi = await EditPriority(urlSearch);
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        throw new Error(error);
      } finally {
        close();
      }
    }
  };

  //   Cập nhật trạng thái của danh mục
  const statusActive = async (id: number) => {
    if (id < 1) NotificationExtension.Fails("Mã danh mục không tồn tại !");
    else {
      open();

      try {
        let urlSearch = "?id=" + id;
        let callapi = await EditStatus(urlSearch);
        close();
        if (isNullOrUndefined(callapi)) {
          NotificationExtension.Fails(
            "Thao tác không thành công, xin vui lòng thử lại !"
          );
        } else {
          if (callapi?.success) {
            NotificationExtension.Success("Thao tác thành công !");
            await fetchData();
          } else NotificationExtension.Fails("Thao tác thất bại !");
        }
        return callapi?.data;
      } catch (error: any) {
        setError("Có lỗi xảy ra khi tải dữ liệu !");
        throw new Error(error);
      } finally {
        close();
      }
    }
  };
  // Hàm mở modal chỉnh sửa danh mục
  const editItem = (id: number, type: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>
            {type === "edit" ? "Chỉnh sửa danh mục" : "Chi tiết danh mục"}
          </Title>
        </>
      ),

      children: (
        <EditView
          onClose={handleDeleteViewClose}
          load={deleteViewStatus}
          id={id}
          fetchData={fetchData}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };

  const deleteItem = (id: any[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa danh mục sản phẩm !</Title>
        </>
      ),
      size: 550,
      children: (
        <Box>
          <Text fw={500} size="18px" mt={5}>
            Bạn có chắc muốn xóa các danh mục sản phẩm này ?
          </Text>
          <Flex justify={"end"} gap={"md"} mt={10}>
            <Button
              color="red"
              leftSection={<IconCheck />}
              onClick={() => {
                deleteItemCategory(
                  id?.map((item) => Number(item)),
                  fetchData()
                );
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </Box>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleDeleteViewClose = (status: number) => {
    setDeleteViewStatus(status);
  };

  // Hàm xử lý chỉnh sửa trạng thái sản phẩm
  const handleEditItemInUse = async (id: number) => {
    await modifyItemStatus(id);
    fetchData();
  };

  // 1. Thêm state để lưu data gốc
  const [originalData, setOriginalData] = useState<CategoryModelTreeNew[]>([]);

  // 2. Hàm lấy data từ API (chỉ gọi 1 lần khi load trang)
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    try {
      let queryParams = `?Skip=${pagination?.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;
      if (formSeachInput.getValues().KeySearch) {
        queryParams += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
      }
      if (formSeachInput.getValues().Active != null) {
        queryParams += `&Active=${formSeachInput.getValues().Active ? true : false
          }`;
      }
      let response = await getDataTreeForm(queryParams);
      if (response && response.success) {
        setOriginalData(response.data); // Lưu data gốc
        setRowCount(response.totalItem || 0);
      }
    } catch (error: any) {
      setOriginalData([]);
      return [];
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  // 5. Khi load trang, chỉ gọi API 1 lần
  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelectionDeferred]);

  const table = useMantineReactTable({
    columns,
    data: originalData || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableSubRowSelection: false, // Tắt tự động chọn danh mục con
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [""],
        right: ["action"],
      },
      // columnVisibility: { id: true },
      density: "xs",
    },
    enableExpanding: true,
    enableExpandAll: false, // Cho phép mở tất cả dòng
    paginateExpandedRows: true, // Phân trang cả dòng mở rộng
    enableStickyFooter: true,
    enableRowSelection: true,
    enableToolbarInternalActions: false,
    mantineTableContainerProps: {
      style: {
        maxHeight: height,
        minHeight: height,
        overflowX: "auto", // Cho phép cuộn ngang
      },
    },
    enableRowVirtualization: true,
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row, cell }) => {
      const indentPx = row.depth * 20;
      const targetColumns = ["STT", "categoryName"]; // Các cột cần lùi

      return {
        style: {
          fontWeight: 550,
          fontSize: "12px",
          padding: "6px 8px",
          paddingLeft: targetColumns.includes(cell.column.id)
            ? `${indentPx + 4}px`
            : "4px",
        },
      };
    },

    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: row.depth === 0 ? "#f9f9f9" : "#fff", // Màu nền cho hàng cha và con
      },
    }),
    getRowId: (row) => row.id?.toString(),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    getSubRows: (row: any) => {
      if (!row.categoryChildModels || !Array.isArray(row.categoryChildModels)) {
        return []; // Trả về mảng rỗng nếu không có dữ liệu con
      }
      return row.categoryChildModels;
    },
  });

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới danh mục !</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          onClose={handleDeleteViewClose}
          load={deleteViewStatus}
          fetchData={fetchData}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (240 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const exportExcel = async (categoryId: number) => {
    open();
    try {
      let url = `/ExportExcel/export-items-by-category?categoryId=${categoryId}`;
      const _url = BASE_API_URL + url;
      const token = localStorage.getItem("authToken");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          Accept: "application/vnd.ms-excel", // Sửa thành Accept thay vì Content-Type
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        },
      });

      if (!response.ok) {
        // Thêm thông tin lỗi chi tiết
        console.error(
          `HTTP error! status: ${response.status}, message: ${response.statusText}`
        );
        NotificationExtension.Fails(
          `Export Excel thất bại! Lỗi: ${response.status} ${response.statusText}`
        );
        return;
      }

      NotificationExtension.Success("Export Excel thành công !");
      const blob = await response.blob();

      // Kiểm tra blob
      if (blob.size === 0) {
        NotificationExtension.Fails("File Excel trống!");
        return;
      }

      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "danh_sach_san_pham_theo_danh_muc_" + _name + ".xlsx";

      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlss); // Sửa thành urlss
    } catch (error: any) {
      console.error("Error:", error);
      NotificationExtension.Fails(`Lỗi kết nối: ${error.message}`);
    } finally {
      close();
    }
  };

  const exportExcelCategory = async () => {
    open();
    try {
      let url = "/ExportExcel/export-categories";
      if (formSeachInput.getValues().KeySearch) {
        url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
      }
      if (formSeachInput.getValues().Active != null) {
        url += `&Active=${formSeachInput.getValues().Active ? true : false}`;
      }
      const _url = BASE_API_URL + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_danh_muc" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };
  // Đây là hàm import thêm danh muc sản phẩm
  const uploadFile = async (e: File) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    // await new Promise((resolve) => setTimeout(resolve, 2000));
    const formData = new FormData();
    // formData.append("file", e);
    formData.append("FormFile", e);

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `${BASE_API_URL}/TblItem/import-excel-to-add-item-to-category`,
        // `${BASE_API_URL}/ImportExcel/import-categories`, 
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          },
          body: formData,
        }
      );

      if (response && response.ok) {
        const result = await response.json();
        if (result.success) {
          NotificationExtension.Success("Import file thành công !");
          setTimeout(() => {
            fetchData();
          }, 1000);
        } else {
          NotificationExtension.Fails(result.message);
        }
      } else {
        NotificationExtension.Fails("Import file thất bại !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
      resetRef.current?.();
    }
  };

  // Hàm import danh mục cho SEO
  const uploadFileCategorySEO = async (e: File | null) => {
    if (!e) {
      NotificationExtension.Fails("File rỗng hoặc chưa chọn file !");
      return;
    }
    open();
    const formData = new FormData();
    formData.append("file", e);

    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `${BASE_API_URL}/ImportExcel/import-categories`,
        {
          method: "POST",
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          },
          body: formData,
        }
      );

      if (response && response.ok) {
        const result = await response.json();
        if (result.success) {
          NotificationExtension.Success("Import danh mục SEO thành công !");
          setTimeout(() => {
            fetchData();
          }, 1000);
        } else {
          NotificationExtension.Fails(result.message);
        }
      } else {
        NotificationExtension.Fails("Import danh mục SEO thất bại !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
      resetRef.current?.();
    }
  };

  const handleDoawnloadImport = async () => {
    open();
    try {
      const urlApi = "/ImportTemplate/update-category";
      const _url = BASE_API_URL + urlApi;

      const response = await fetch(_url, { method: "GET" });

      if (!response.ok) {
        // nếu server trả JSON lỗi dưới dạng text/blob -> đọc và hiển thị message nếu có
        const text = await response.text();
        try {
          const json = JSON.parse(text);
          NotificationExtension.Fails(json?.message || `Tải file mẫu thất bại! (${response.status})`);
        } catch {
          NotificationExtension.Fails(`Tải file mẫu thất bại! (${response.status})`);
        }
        return;
      }

      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        NotificationExtension.Fails("File mẫu rỗng hoặc không tồn tại!");
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Template_Mau.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      NotificationExtension.Success("Tải file mẫu thành công !");
    } catch (error: any) {
      console.error("Error downloading template:", error);
      NotificationExtension.Fails("Tải file mẫu thất bại");
    } finally {
      close();
    }
  };
  useEffect(() => {
    if (file) {
      if (
        file &&
        (file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "application/vnd.ms-excel")
      )
        uploadFile(file);
      else NotificationExtension.Fails("File không đúng định đạng Excel !");
    }
  }, [file]);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      {!isModal && (
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <BreadCrumb></BreadCrumb>
          <Flex gap={"md"} align={"center"}>
            <Button
              leftSection={<IconTrash size={20} />}
              color="red"
              onClick={() => deleteItem(selectIds)}
              disabled={selectIds.length === 0}
            >
              Xóa (đã chọn)
            </Button>
            <AppAction
              openModal={openModal}
              // openModalDelete={openModalDelete}
              // openModalEdit={openModalEdit}
              isUpdateSearchItem={true}
              openExportExcel={exportExcelCategory}
            ></AppAction>
            <FileButton onChange={setFile} resetRef={resetRef}>
              {(props) => (
                <Button
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  {...props}
                >
                  Import sản phẩm theo danh mục
                </Button>
              )}
            </FileButton>

            {/* Nút Import danh mục cho SEO */}
            <FileButton onChange={uploadFileCategorySEO} resetRef={resetRef}>
              {(props) => (
                <Button
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  {...props}
                >
                  Import danh mục SEO
                </Button>
              )}
            </FileButton>
            <Button
              leftSection={
                <IconFileDownload
                  style={{ width: rem(14), height: rem(14) }}
                />
              }
              onClick={() => handleDoawnloadImport()}
            >
              File mẫu import update cho SEO
            </Button>
          </Flex>
        </Flex>
      )}
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        ref={headerRef}
      >
        {/* Thông báo thời gian đồng bộ dữ liệu lên web */}
        <Box
          style={{
            background: "#fffbe6",
            border: "1.5px solid #ffe58f",
            borderRadius: 8,
            padding: "5px",
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontWeight: 600,
            color: "#ad6800",
            fontSize: 14,
          }}
        >
          <IconTimeDuration15
            size={22}
            color="#faad14"
            style={{ marginRight: 6 }}
          />
          <span>
            <b>Lưu ý:</b> Sau khi cập nhật,có thể dữ liệu sẽ được đồng bộ lên
            website trong khoảng <b>15-30 phút</b>. Vui lòng kiểm tra lại sau
            thời gian này để thấy thay đổi.
          </span>
        </Box>
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <Grid w={"90%"}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                size="md"
                width="100%"
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("KeySearch")}
                {...formSeachInput.getInputProps("KeySearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
              />
            </Grid.Col>
            {/* <Grid.Col span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Lọc theo nổi bật"
                size="md"
                leftSection={<IconFilter color="#15aabf" />}
                data={[
                  {
                    value: "Y",
                    label: "Nổi bật",
                  },
                  {
                    value: "N",
                    label: "Không nổi bật",
                  },
                ]}
              />
            </Grid.Col> */}
            <Grid.Col span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Lọc theo Trạng thái"
                size="md"
                leftSection={<IconFilter color="#15aabf" />}
                data={[
                  {
                    value: "A",
                    label: "Hiển thị",
                  },
                  {
                    value: "I",
                    label: "Không hiển thị",
                  },
                ]}
                key={formSeachInput.key("Active")}
                {...formSeachInput.getInputProps("Active")}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                size="md"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
          <Button
            color="teal"
            variant="filled"
            leftSection={<IconCheck size={14} />}
            w={"10%"}
            onClick={() => {
              setValueCategory(selectIds);
              modals.closeAll();
            }}
            disabled={selectIds.length < 1}
          >
            Xác nhận
          </Button>
        </Flex>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
      <Drawer
        opened={openedProductCategory}
        onClose={closeProductCategory}
        offset={8}
        size={"100%"}
        radius="md"
        title={
          <Badge color="blue" variant="light">
            Danh sách sản phẩm - {categorySelect?.categoryName}
          </Badge>
        }
      >
        <ProductCategory categoryId={categorySelect?.categorySelect} />
      </Drawer>
    </Box>
  );
};

export default HomeViewCategoryV2;
